<template>
  <div class="premixes-container mt-3 py-3 pl-3 pr-0">
    <h4 class="pl-4 text-capitalize">
      {{ $resourceString["virtualtray.premixes.modal.header"] }}
    </h4>
    <div
      class="d-flex pl-3 pb-4 results-wrapper flex-wrap justify-content-between"
    >
      <div
        class="col-12 col-md-6 result-wrapper pr-3"
        v-for="(premix, index) in premixes.sort((a, b) =>
          a.name > b.name ? 1 : b.name > a.name ? -1 : 0
        )"
        :key="index"
        @click="$emit('onPremixClick', premix)"
      >
        <div class="img-wrapper">
          <div
            slot="item"
            class="result-img"
            :item="premix"
            :style="[{ backgroundImage: `url('${premix.imagePath}')` }]"
          />
        </div>
        <span class="text-uppercase">{{ premix.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      premixes: "virtualTray/premixes"
    })
  }
};
</script>

<style></style>
